import { Component, OnInit } from '@angular/core';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';
import { AuthenticationService } from '../service/authentication.service';
import { ApiService } from '../service/api.service';
import { Constants } from '../constants/constants';
import { BillingPeriodCycle, Period } from '../shared/model/billing-period-cycle.model';
import { DatePipe } from '@angular/common';
import { isNullOrUndefined } from 'util';
import { EnvService } from '../service/env.service';

@Component({
  selector: 'app-charging',
  templateUrl: './charging.component.html',
  styleUrls: ['./charging.component.scss']
})
export class ChargingComponent implements OnInit {

  readonly LOCALE = this.env.LOCALE;

  fleetId: string;
  accountCategory: string;
  accountType:string;
  chargingPeriodOptions: Array<BillingPeriodCycle> = [];
  selectedSelectionRange: BillingPeriodCycle;
  selectedFromDate = new Date();
  selectedToDate = new Date();
  today = new Date();
  charges = [];
  usageData: Array<any> = new Array<any>();
  locationMap: Map<string, any> = new Map();
  selectedService: string;

  constructor(private apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private toast: ToastService, private datePipe: DatePipe,
    private env: EnvService) { }

  ngOnInit() {
    this.getBillingCycles();
    // this.getAccountLocations();
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.type;
  }

  getBillingCycles() {
    this.utilService.showSpinner();
    this.apiService.getBillingCycles().then((data) => {
      this.utilService.hideSpinner();
      console.log("Billing cycles::", data);
      this.prepareBillingCycle(data);
      if(this.chargingPeriodOptions.length > 0) {
        this.selectedSelectionRange = this.chargingPeriodOptions[0];
        this.onChargingPeriodChange(0);
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getBillingCycles();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  prepareBillingCycle(data: Array<Period>) {
    this.chargingPeriodOptions = [];
    if(data != null && data.length > 0) {
      for (var i = 0; i < data.length; i++) {
        var startDate = data[i].startDate;
        var endDate = data[i].endDate;
        /* if (!Constants.HERTZ_ACCOUNT_ID.includes(this.authService.loggedInUser.accountId) && i == 0) {
          // this.chargingPeriodOptions.push({
          //   "periodName": "Current Billing Cycle",
          //   "period": {
          //     "startDate": startDate,
          //     "endDate": endDate
          //   }
          // });
          continue;
        } */
        // if(i == 1) {
        //   this.chargingPeriodOptions.push({
        //     "periodName": "Previous Billing Cycle",
        //     "period": {
        //       "startDate": startDate,
        //       "endDate": endDate
        //     }
        //   });
        //   continue;
        // }

        // if ((Constants.HERTZ_ACCOUNT_ID.includes(this.authService.loggedInUser.accountId) && i == 0)) {
        if (i == 0) {
          this.chargingPeriodOptions.push({
            "billingCycleId": data[i].billingCycleId,
            "periodName": 'Charges Till Date',
            "period": {
              "startDate": startDate,
              "endDate": endDate
            }
          });
        } else {
          this.chargingPeriodOptions.push({
            "billingCycleId": data[i].billingCycleId,
            "periodName": this.datePipe.transform(startDate, 'MM/dd/yyyy', 'Z') + " - " + this.datePipe.transform(endDate, 'MM/dd/yyyy', 'Z'),
            "period": {
              "startDate": startDate,
              "endDate": endDate
            }
          });
        }
      };
    }
  }

  onChargingPeriodChange(selectedPeriod) {
    console.log("selected selectedPeriod :", selectedPeriod);
    var selectedChargingPeriod = this.chargingPeriodOptions[selectedPeriod];
    this.selectedSelectionRange = selectedChargingPeriod;
    this.selectedFromDate = new Date(selectedChargingPeriod.period.startDate);
    this.selectedToDate = new Date(selectedChargingPeriod.period.endDate);
    /* if (this.isHertzAccount()) {
      this.getChargesForBillingCycle();
    } else {
      this.getChargesBetweenDate();
    } */
    this.getChargesForBillingCycle();
  }

  getChargesBetweenDate() {
    this.charges = [];
    this.utilService.showSpinner();
    var payload = {
      "fromDate": this.selectedFromDate, 
      "toDate": this.selectedToDate
    }
    this.apiService.getAccountCharges(payload).then((data) => {
      this.utilService.hideSpinner();
      console.log("Charging data::", data);
      if(!isNullOrUndefined(data)) {
        this.charges = data.packageCharges;
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getChargesBetweenDate();
        });
      }
      else {
        this.utilService.hideSpinner();
        // if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        // else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getChargesForBillingCycle() {
    this.charges = [];
    this.utilService.showSpinner();
    var payload = {
      "billingCycleId": this.selectedSelectionRange.billingCycleId,
    }
    this.apiService.getChargesForBillingCycle(payload).then((data) => {
      this.utilService.hideSpinner();
      console.log("Charging data::", data);
      if (data) {
        this.charges = data.chargeItems;
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getChargesForBillingCycle();
        });
      }
      else {
        this.utilService.hideSpinner();
        // if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        // else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getUDR(serviceName: string) {
    this.usageData = [];
    this.selectedService = serviceName;
    this.utilService.showSpinner();
    var request = {
      "fromDate" : this.selectedFromDate,//"2019-12-11T09:42:57.830Z",
      "toDate" : this.selectedToDate,//"2020-12-14T09:42:57.830Z"
      "service": serviceName
    }
    this.apiService.getUDR(request).then((data) => {
      this.utilService.hideSpinner();
      console.log("UDR data::", data);
      this.usageData = data;
      this.openServiceUsage();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getUDR(serviceName);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  getAccountLocations() {
    this.utilService.showSpinner();
    this.apiService.getFleetLocationList().then((data) => {
      this.utilService.hideSpinner();
      console.log("Account locations data::", data);
      if(data && data.length > 0) {
        this.prepareLocationMap(data);
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountLocations();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  prepareLocationMap(locations: Array<any>) {
    this.locationMap.clear();
    locations.forEach(location => {
      this.locationMap.set(location.id, location);
    });
    console.log("location map::", this.locationMap);
  }

  openServiceUsage() {
    document.getElementById("openServiceUsage").click();
  }

  isChargingPeriodAvailable(): boolean {
    if (this.chargingPeriodOptions && this.chargingPeriodOptions.length > 0) {
      return true;
    }
    return false;
  }

  /* isHertzAccount(): boolean {
    if (Constants.HERTZ_ACCOUNT_ID.includes(this.authService.loggedInUser.accountId))
      return true;
    return false;
  } */

  getTotalTransactions(serviceCharges) {
    return serviceCharges && serviceCharges.length ? serviceCharges.reduce((acc, curr) => acc + (curr.totalTransactions || 0), 0) : "";
  }

  getSuccessfulTransactions(serviceCharges) {
    return serviceCharges && serviceCharges.length ? serviceCharges.reduce((acc, curr) => acc + (curr.successfulTransactions || 0), 0) : "";
  }

  getFailedTransactions(serviceCharges) {
    return serviceCharges && serviceCharges.length ? serviceCharges.reduce((acc, curr) => acc + (curr.failedTransactions || 0), 0) : "";
  }

}
